import React, { useEffect, useState } from "react";
import api, { formatTL, formatDateTime, formatDuration } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Plate } from "@/components/Plate";
import PayMethodDialog from "@/components/PayMethodDialog";
import { CheckCircle } from "@phosphor-icons/react";

export default function OperatorUnpaid() {
  const [rows, setRows] = useState([]);
  const [payFor, setPayFor] = useState(null);

  const load = async () => {
    const { data } = await api.get("/sessions/unpaid");
    setRows(data);
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-4 animate-fade-in">
      <div>
        <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Bekleyen</div>
        <h1 className="text-3xl font-bold tracking-tight">Ödenmemiş</h1>
      </div>

      <div className="space-y-3">
        {rows.length === 0 && <Card className="rounded-sm border-border"><CardContent className="p-8 text-center text-muted-foreground">Ödenmemiş oturum yok 🎉</CardContent></Card>}
        {rows.map((s) => {
          const isSubscriber = !!s.subscription_live_detected || !!s.is_subscriber;
          return (
          <Card key={s.id} className={`rounded-sm ${isSubscriber ? "border-green-500 border-2 bg-green-50/40" : "border-border"}`} data-testid={`op-unpaid-${s.plate}`}>
            <CardContent className="p-4">
              <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
                <div className="flex items-center gap-2 flex-wrap">
                  <Plate country={s.country_code}>{s.plate}</Plate>
                  {isSubscriber && (
                    <Badge
                      data-testid={`op-unpaid-muaf-${s.plate}`}
                      className="rounded-sm bg-green-600 hover:bg-green-600 text-white uppercase tracking-widest text-[10px] font-semibold gap-1 border-transparent"
                    >
                      <CheckCircle size={12} weight="fill" /> Muaf (Abone)
                    </Badge>
                  )}
                </div>
                <span className="text-xs uppercase tracking-widest text-muted-foreground">{s.parking_lot_key === "ust_kat" ? "Üst" : "Alt"}</span>
              </div>
              <div className="grid grid-cols-2 gap-2 text-xs mb-3">
                <div><div className="text-muted-foreground uppercase tracking-widest">Çıkış</div><div>{formatDateTime(s.exit_time)}</div></div>
                <div><div className="text-muted-foreground uppercase tracking-widest">Süre</div><div className="font-mono">{formatDuration(s.duration_minutes)}</div></div>
              </div>
              <div className="flex items-center justify-between">
                <div className={`font-mono font-bold text-xl ${isSubscriber ? "text-green-700 line-through opacity-70" : "text-destructive"}`}>{formatTL(s.fee)}</div>
                <Button data-testid={`op-pay-${s.plate}`} onClick={() => setPayFor(s)} className={`rounded-sm uppercase text-xs tracking-widest font-semibold ${isSubscriber ? "bg-green-600 hover:bg-green-700 text-white" : "bg-primary text-primary-foreground hover:bg-primary/90"}`} size="sm">
                  {isSubscriber ? "Muaf İşaretle" : "Ödeme Al"}
                </Button>
              </div>
            </CardContent>
          </Card>
        );})}
      </div>

      <PayMethodDialog session={payFor} open={!!payFor} onOpenChange={(o) => !o && setPayFor(null)} onDone={load} />
    </div>
  );
}
